import template from './swag-cms-extensions-form-editor-settings-group-field.html.twig';
import './swag-cms-extensions-form-editor-settings-group-field.scss';

export default {
    template,
    data() {
        return {
            displayHeader: true,
        };
    },
    computed: {
        item() {
            return Shopware.Store.get('swCmsDetailCurrentCustomForm').activeItem;
        },

        fieldComponentName() {
            return `swag-cms-extensions-form-editor-settings-field-type-${this.item.type}`;
        },
    },
    watch: {
        item(newItem, oldItem) {
            if (newItem.id === oldItem.id) {
                return;
            }

            // This prevents unintentional removal of api errors on active item change
            this.displayHeader = false;

            this.$nextTick(() => {
                this.displayHeader = true;
            });
        },
    },
}
